angular.module('app.directives.checkout').directive('checkoutBillingAddress', () => {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
    },
    template: `
<div class="form-group">
  <label for="address" class="control-label">Street Address</label>
  <input ng-model="vm.billing.address" id="bill_address" name="address" type="text" class="form-control" autocomplete="address" placeholder="" required>
</div>
<div class="row">
  <div class="col-md-6">
    <div class="form-group">
      <label for="city" class="control-label">City</label>
      <input ng-model="vm.billing.city" id="city" name="city" type="text" class="form-control" autocomplete="city" placeholder="" required>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label for="state" class="control-label">State/Region</label>
      <input ng-if="vm.billing.country != 'US'"
              ng-model="vm.billing.state" id="state" name="state" type="text" class="form-control" autocomplete="state" placeholder="" required>
      <select ng-if="vm.billing.country == 'US'"
              ng-model="vm.billing.state"
              ng-options="c.code as c.name for c in vm.states"
              id="state" name="state" class="form-control" required>
      </select>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-6">
    <div class="form-group">
      <label for="zip" class="control-label">Postal Code</label>
      <input ng-model="vm.billing.postal_code"
             id="zip" name="zip" type="text" class="form-control" autocomplete="zip" placeholder="" required>
      <p ng-show="vm.salesTaxCents > 0" class="help-block">
        Sales tax on the hardware purchase is required for this zip code. Your total has been updated to reflect this charge.
      </p>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label for="country" class="control-label">Country</label>
      <select ng-model="vm.billing.country"
              ng-init="vm.billing.country = vm.billing.country || 'US'"
              ng-options="c.code as c.name for c in vm.countries"
              id="country" name="country" class="form-control" required>
      </select>
    </div>
  </div>
</div>
      `,
  };
});



// WEBPACK FOOTER //
// ./app/directives/checkout/checkout-billing-address.js